/* eslint 'jsx-a11y/anchor-is-valid': 'off'  */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Redirect } from 'react-router-dom';
import '../../../../Assets/EnsembleStyles/Administration/administration.css';
// import { FaQuestionCircle } from 'react-icons/fa';
import { ClearClientData } from '../../../../action/Administration/administrationAction';
import { getAllResources } from '../../../../action/cultureAction';

class Administration extends Component {
    componentWillMount(){
        if(this.props.getLabels["ActionsAndSettings.UAText.Text"] === undefined){
            this.props.getAllResources();
        }
    }
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            redirect: false,
            installations_redirect: false,
            tracer_ensemble_license_redirect: false,
            add_new_user_redirect: false,
            user_profiles_redirect: false,
            userchangelog_redirect: false,
            siteInfo_redirect: false,
            system_status_redirect:false
        }
    }
    redirect(link_name) {
        if (link_name === "installations_redirect") { this.setState({ redirect: true, installations_redirect: true }); }
        else if (link_name === "tracer_ensemble_license_redirect") { this.setState({ redirect: true, tracer_ensemble_license_redirect: true }); }
        else if (link_name === "add_new_user_redirect") {this.props.ClearClientData(); this.setState({ redirect: true, add_new_user_redirect: true }); }
        else if (link_name === "user_profiles_redirect") { this.setState({ redirect: true, user_profiles_redirect: true }); }
        else if (link_name === "userchangelog_redirect") { this.setState({ redirect: true, userchangelog_redirect: true }); }
        else if (link_name === "SiteInfo_redirect") { this.setState({ redirect: true, siteInfo_redirect: true }); }
        else if(link_name === "system_status_redirect"){ this.setState({redirect: true, system_status_redirect:true}); }
    }

    render(getLabels) {
        if (this.state.redirect && this.state.installations_redirect) { return <Redirect to={"/SystemAdmin/BuildingInstallation"} /> }
        if (this.state.redirect && this.state.tracer_ensemble_license_redirect) { return <Redirect to={"/SystemAdmin/ManageSiteLicense"} /> }
        if (this.state.redirect && this.state.add_new_user_redirect) { return <Redirect to={"/SystemAdmin/AddModifyUser"} /> }
        if (this.state.redirect && this.state.user_profiles_redirect) { return <Redirect to={"/SystemAdmin/ManageUsers"} /> }
        if (this.state.redirect && this.state.userchangelog_redirect) { return <Redirect to={"/SystemAdmin/UserChangeLog"} /> }
        if (this.state.redirect && this.state.siteInfo_redirect) { return <Redirect to={"/SystemAdmin/SiteInfo"} /> }
        if (this.state.redirect && this.state.system_status_redirect) { return <Redirect to={"/SystemAdmin/SystemStatus"}/>}
        let label = this.props.getLabels;

        return (
            <div className="dbd_container">
                <div className="admin_page_titlebar">
                    <div className="admin_subheader">
                        <h2 className="dbd_sub_heading">{label['AdministrationTHN.Text'] !== undefined ?  label['AdministrationTHN.Text'] : "Actions and Settings"}</h2>
                        {/* <FaQuestionCircle className="dbd_right_icon Ensemble_Icon Ensemble_question_Icon link_cursor" /> */}
                    </div>
                    <p className="sub_text">{label['ActionsAndSettings.UAText.Text'] !== undefined ? label['ActionsAndSettings.UAText.Text'] : "Click links below to access frequently used actions and settings."}</p>
                </div>

                <div className="main_container dbd_main_container">

                    <div className="content_1">
                        <p className="admin_sub_heading_context">{label['ActionsAndSettings.Buildings.GroupHeader.Text'] !== undefined ? label['ActionsAndSettings.Buildings.GroupHeader.Text'] : "Buildings"}</p>
                        <hr className="under_line" />
                        <div className="sub_content">
                            <a className="nv_link link_cursor" onClick={() => { this.redirect("installations_redirect") }}>{label['ActionsAndSettings.Buildings.BuildingInstallationLink.Text'] !== undefined ? label['ActionsAndSettings.Buildings.BuildingInstallationLink.Text'] : "Installation"}</a>
                            <a className="nv_link link_cursor" onClick={() => { this.redirect("SiteInfo_redirect") }}>User Accounts</a>
                        </div>
                    </div>

                    <div className="content_1">
                        <p className="admin_sub_heading_context">{label['ActionsAndSettings.LogsReports.GroupHeader.Text'] !== undefined ? label['ActionsAndSettings.LogsReports.GroupHeader.Text'] : "Logs and Reports"}</p>
                        <hr className="under_line" />
                        <div className="sub_content">
                            <a className="nv_link link_cursor" onClick={() => { this.redirect("userchangelog_redirect") }}>{label['ActionsAndSettings.LogsReports.UserChangeLogLink.Text'] !== undefined ? label['ActionsAndSettings.LogsReports.UserChangeLogLink.Text'] : "User Change Log"}</a>
                        </div>
                    </div>

                    <div className="content_1">
                        <p className="admin_sub_heading_context" >{label['ActionsAndSettings.System.GroupHeader.Text'] !== undefined ? label['ActionsAndSettings.System.GroupHeader.Text'] : "System"}</p>
                        <hr className="under_line" />
                        <div className="sub_content">
                            <a className="nv_link link_cursor" onClick={() => { this.redirect("tracer_ensemble_license_redirect") }}>{label['ActionsAndSettings.System.TracerEnsembleLicensingLink.Text'] !== undefined ? label['ActionsAndSettings.System.TracerEnsembleLicensingLink.Text'] : "Licensing"}</a>
                            &nbsp;&nbsp;
                            <a className="nv_link link_cursor" onClick={() => { this.redirect("system_status_redirect")}}>{label['ActionsAndSettings.System.SystemStatusLink.Text'] !== undefined ? label['ActionsAndSettings.System.SystemStatusLink.Text']:"System Status"}</a>
                        </div>
                    </div>

                    <div className="content_1">
                        <p className="admin_sub_heading_context">{label['ActionsAndSettings.UserRole.GroupHeader.Text'] !== undefined ? label['ActionsAndSettings.UserRole.GroupHeader.Text'] : "Users and Roles"}</p>
                        <hr className="under_line" />
                        <div className="sub_content">
                            <a className="nv_link link_cursor" onClick={() => { this.redirect("add_new_user_redirect") }} >{label['ActionsAndSettings.UserRole.NewUserLink.Text'] !== undefined ? label['ActionsAndSettings.UserRole.NewUserLink.Text'] : "Add a New User"}</a>
                            <a className="nv_link link_cursor" onClick={() => { this.redirect("user_profiles_redirect") }}>{label['ActionsAndSettings.UserRole.UserProfileLink.Text'] !== undefined ? label['ActionsAndSettings.UserRole.UserProfileLink.Text'] : "User Profiles"}</a>
                        </div>
                    </div>

                </div>

            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.SystemAdmin_LabelsBasedOnPreference
    };
};

const mapDispatchToProps = dispatch => {
    return {
        ClearClientData: () => dispatch(ClearClientData()),
        getAllResources: () => dispatch(getAllResources())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Administration);
